<template>
  <div class="editor-root">
    <div class="toolbar">
      <div class="toolbar-group">
        <button type="button" class="tool-btn" title="Titre moyen" @mousedown.prevent="formatBlock('H2')">
          H2
        </button>
        <button type="button" class="tool-btn" title="Petit titre" @mousedown.prevent="formatBlock('H3')">
          H3
        </button>
        <button type="button" class="tool-btn" title="Paragraphe" @mousedown.prevent="formatBlock('P')">
          P
        </button>
        <button type="button" class="tool-btn" title="Citation" @mousedown.prevent="formatBlock('BLOCKQUOTE')">
          <svg viewBox="0 0 16 16" aria-hidden="true">
            <path d="M6.854 2.146A.5.5 0 0 1 7 2.5v2a.5.5 0 0 1-.5.5H5v1c0 1.105-.895 2-2 2H2v2.5a.5.5 0 0 1-.854.354l-1-1A.5.5 0 0 1 0 9.5v-2A2.5 2.5 0 0 1 2.5 5H3V4a2 2 0 0 1 2-2h1.5a.5.5 0 0 1 .354.146m9 0A.5.5 0 0 1 16 2.5v2a.5.5 0 0 1-.5.5H14v1c0 1.105-.895 2-2 2h-1v2.5a.5.5 0 0 1-.854.354l-1-1A.5.5 0 0 1 9 9.5v-2A2.5 2.5 0 0 1 11.5 5h.5V4a2 2 0 0 1 2-2h1.5a.5.5 0 0 1 .354.146"/>
          </svg>
        </button>
      </div>

      <div class="toolbar-group">
        <button type="button" class="tool-btn" title="Gras" @mousedown.prevent="exec('bold')">
          <svg viewBox="0 0 16 16" aria-hidden="true">
            <path d="M8.21 13c2.269 0 3.79-1.248 3.79-3.125 0-1.294-.923-2.227-2.31-2.603 1.12-.43 1.812-1.3 1.812-2.488C11.502 2.78 10.108 2 8.287 2H4v11zM5.674 3.326h2.37c1.298 0 2.012.533 2.012 1.495 0 .997-.758 1.56-2.115 1.56H5.674zm0 4.38h2.615c1.536 0 2.324.598 2.324 1.738 0 1.147-.804 1.73-2.387 1.73H5.674z"/>
          </svg>
        </button>
        <button type="button" class="tool-btn" title="Italique" @mousedown.prevent="exec('italic')">
          <svg viewBox="0 0 16 16" aria-hidden="true">
            <path d="M7.991 11.674 9.53 4.326h1.568l.106-.532H7.36l-.106.532h1.684l-1.54 7.348H5.83l-.107.532h3.844l.106-.532z"/>
          </svg>
        </button>
        <button type="button" class="tool-btn" title="Souligner" @mousedown.prevent="exec('underline')">
          <svg viewBox="0 0 16 16" aria-hidden="true">
            <path d="M5.5 3v4a2.5 2.5 0 0 0 5 0V3h1v4a3.5 3.5 0 1 1-7 0V3zM4.5 13.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1H5a.5.5 0 0 1-.5-.5"/>
          </svg>
        </button>
        <button type="button" class="tool-btn" title="Barre" @mousedown.prevent="exec('strikeThrough')">
          <svg viewBox="0 0 16 16" aria-hidden="true">
            <path d="M6.5 13.5a2.5 2.5 0 0 0 5 0c0-1.193-.927-1.965-2.293-2.614L8.5 10.5H6v-1h10v1h-5.314l-.736-.308C8.594 9.735 7.5 9.207 7.5 8c0-.818.716-1.5 2-1.5s2 .682 2 1.5h1c0-1.5-1.23-2.5-3-2.5S6.5 6.5 6.5 8c0 .726.257 1.33.69 1.834H0v-1h6.196A2.4 2.4 0 0 1 5.5 7c0-1.607 1.556-2.5 3.5-2.5 1.87 0 3.5.9 3.5 2.5h-1c0-1.012-1.056-1.5-2.5-1.5s-2.5.488-2.5 1.5c0 .866.791 1.325 2.09 1.86l.013.005.828.345c1.658.69 3.069 1.542 3.069 3.29a3.5 3.5 0 0 1-7 0z"/>
          </svg>
        </button>
      </div>

      <div class="toolbar-group">
        <button type="button" class="tool-btn" title="Liste a puces" @mousedown.prevent="exec('insertUnorderedList')">
          <svg viewBox="0 0 16 16" aria-hidden="true">
            <path d="M2 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M3.5 4h11v1h-11zm-1.5 4.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M3.5 8h11v1h-11zM2 12.5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0M3.5 12h11v1h-11z"/>
          </svg>
        </button>
        <button type="button" class="tool-btn" title="Liste numerotee" @mousedown.prevent="exec('insertOrderedList')">
          <svg viewBox="0 0 16 16" aria-hidden="true">
            <path d="M1.713 11.086v.934H.57v.98h2.236v-.727H1.76v-.01l.654-.646c.404-.397.789-.839.789-1.465 0-.727-.522-1.292-1.403-1.292-.466 0-.867.133-1.153.33l.22.767c.19-.133.46-.263.784-.263.42 0 .63.238.63.57 0 .348-.295.676-.74 1.11zM2.094 4.566v3.71H1.05V5.414H1.04l-.906.52-.216-.787 1.114-.58zM5.5 4h10v1h-10zm0 4h10v1h-10zm0 4h10v1h-10z"/>
          </svg>
        </button>
        <button type="button" class="tool-btn" title="Aligner a gauche" @mousedown.prevent="exec('justifyLeft')">
          <svg viewBox="0 0 16 16" aria-hidden="true">
            <path d="M2 12.5a.5.5 0 0 1 .5-.5h6a.5.5 0 0 1 0 1h-6a.5.5 0 0 1-.5-.5m0-4a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11A.5.5 0 0 1 2 8.5m0-4a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 0 1h-8A.5.5 0 0 1 2 4.5"/>
          </svg>
        </button>
        <button type="button" class="tool-btn" title="Centrer" @mousedown.prevent="exec('justifyCenter')">
          <svg viewBox="0 0 16 16" aria-hidden="true">
            <path d="M2.5 12a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1zm2-4a.5.5 0 0 0 0 1h7a.5.5 0 0 0 0-1zm-2-4a.5.5 0 0 0 0 1h11a.5.5 0 0 0 0-1z"/>
          </svg>
        </button>
        <button type="button" class="tool-btn" title="Aligner a droite" @mousedown.prevent="exec('justifyRight')">
          <svg viewBox="0 0 16 16" aria-hidden="true">
            <path d="M13.5 12a.5.5 0 0 1 0 1h-6a.5.5 0 0 1 0-1zm0-4a.5.5 0 0 1 0 1h-11a.5.5 0 0 1 0-1zm0-4a.5.5 0 0 1 0 1h-8a.5.5 0 0 1 0-1z"/>
          </svg>
        </button>
      </div>

      <div class="toolbar-group">
        <label class="color-picker" title="Couleur du texte">
          <input type="color" @input="setColor($event.target.value)">
        </label>
        <button type="button" class="tool-btn" title="Ajouter un lien" @mousedown.prevent="createLink">
          <svg viewBox="0 0 16 16" aria-hidden="true">
            <path d="M6.354 5.5H4a3 3 0 0 0 0 6h3a3 3 0 0 0 2.83-2H8.793A2 2 0 0 1 7 10.5H4a2 2 0 1 1 0-4h2.354z"/>
            <path d="M9.646 10.5H12a3 3 0 1 0 0-6H9a3 3 0 0 0-2.83 2h1.037A2 2 0 0 1 9 5.5h3a2 2 0 1 1 0 4H9.646z"/>
            <path d="M5.5 8a.5.5 0 0 1 .5-.5h4a.5.5 0 0 1 0 1H6A.5.5 0 0 1 5.5 8"/>
          </svg>
        </button>
        <button type="button" class="tool-btn" title="Retirer la mise en forme" @mousedown.prevent="clearFormatting">
          <svg viewBox="0 0 16 16" aria-hidden="true">
            <path d="M11.354 1.146a.5.5 0 0 1 0 .708L8.207 5H9.5a.5.5 0 0 1 .447.724l-3 6a.5.5 0 0 1-.894-.448L8.691 6H7.5a.5.5 0 0 1-.354-.854l3.5-3.5a.5.5 0 0 1 .708 0M2 13.5a.5.5 0 0 1 .5-.5H13a.5.5 0 0 1 0 1H2.5a.5.5 0 0 1-.5-.5"/>
          </svg>
        </button>
      </div>
    </div>

    <div
        ref="editable"
        class="editable"
        contenteditable="true"
        data-placeholder="Description"
        @input="emitValue"
    ></div>
  </div>
</template>

<script>
export default {
  name: 'RichTextEditor',

  props: {
    modelValue: {
      type: String,
      default: ''
    }
  },

  emits: ['update:modelValue'],

  watch: {
    modelValue() {
      this.syncFromModel();
    }
  },

  mounted() {
    document.execCommand('styleWithCSS', false, true);
    this.syncFromModel();
  },

  methods: {
    syncFromModel() {
      const element = this.$refs.editable;
      if (!element) {
        return;
      }

      const nextValue = this.modelValue || '';
      if (element.innerHTML !== nextValue) {
        element.innerHTML = nextValue;
      }
    },

    emitValue() {
      this.$emit('update:modelValue', this.$refs.editable?.innerHTML || '');
    },

    focusEditor() {
      this.$refs.editable?.focus();
    },

    exec(command, value = null) {
      this.focusEditor();
      document.execCommand(command, false, value);
      this.emitValue();
    },

    formatBlock(tagName) {
      this.exec('formatBlock', tagName);
    },

    createLink() {
      const url = window.prompt('URL');
      if (!url) {
        return;
      }

      this.exec('createLink', url);
    },

    setColor(value) {
      if (!value) {
        return;
      }

      this.exec('foreColor', value);
    },

    clearFormatting() {
      this.exec('removeFormat');
      this.exec('unlink');
    }
  }
}
</script>

<style scoped>
.editor-root {
  background: #2a2b2e;
  border: 1px solid #45474d;
  border-radius: 18px;
  overflow: hidden;
}

.toolbar {
  display: flex;
  flex-wrap: wrap;
  gap: 0.45rem;
  padding: 0.6rem;
  border-bottom: 1px solid #45474d;
  background: #252629;
}

.toolbar-group {
  display: flex;
  gap: 0.35rem;
}

.tool-btn,
.color-picker {
  border: 1px solid #5a5d65;
  background: #323336;
  color: white;
  border-radius: 9px;
  min-width: 34px;
  height: 32px;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 0.55rem;
  transition: border-color 0.18s ease, color 0.18s ease, transform 0.18s ease;
}

.tool-btn svg {
  width: 14px;
  height: 14px;
  fill: currentColor;
}

.color-picker {
  width: 34px;
  overflow: hidden;
  padding: 0;
}

.color-picker input {
  width: 100%;
  height: 100%;
  border: none;
  background: transparent;
  padding: 0;
  cursor: pointer;
}

.tool-btn:hover,
.color-picker:hover {
  border-color: #00f0ff;
  color: #00f0ff;
  transform: translateY(-1px);
}

.editable {
  min-height: 280px;
  padding: 1rem;
  color: white;
  outline: none;
  line-height: 1.6;
}

.editable:empty::before {
  content: attr(data-placeholder);
  color: #8f95a1;
}

.editable :deep(a) {
  color: #00f0ff;
}
</style>
